import api, { apiBaseUrl } from '../api'

const saveDocumentation = (token, data, pk) => {
  return api.privatePatch(`/v1/property_documentation/${pk}/`, { token, data })
}

export default {
  saveDocumentation
}